import { render, staticRenderFns } from "./BannerManagementView.vue?vue&type=template&id=16d50164&scoped=true&"
import script from "./BannerManagementView.vue?vue&type=script&lang=js&"
export * from "./BannerManagementView.vue?vue&type=script&lang=js&"
import style0 from "./BannerManagementView.vue?vue&type=style&index=0&id=16d50164&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d50164",
  null
  
)

export default component.exports